import { render, staticRenderFns } from "./dutyConfig.vue?vue&type=template&id=7f757292&scoped=true"
import script from "./dutyConfig.vue?vue&type=script&lang=js"
export * from "./dutyConfig.vue?vue&type=script&lang=js"
import style0 from "./dutyConfig.vue?vue&type=style&index=0&id=7f757292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f757292",
  null
  
)

export default component.exports